module.exports = __webpack_public_path__ + "static/media/teploschetchik_korrektor.d9803490.png";